"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.FormField = void 0;
var component_fields_1 = require("@doordash/component-fields");
var lib_permissions_1 = require("@doordash/lib-permissions");
var React = __importStar(require("react"));
var Form_1 = require("./Form");
var ReadOnlyValue_1 = require("./ReadOnlyValue");
var types_1 = require("./types");
var InnerFormField = function (_a) {
    var formField = _a.formField, value = _a.value, error = _a.error;
    var dispatch = React.useContext(Form_1.FormDispatchContext);
    var Field = formField.component || types_1.FieldTypes["" + formField.type] || component_fields_1.TextField;
    return (React.createElement(Field, __assign({ size: component_fields_1.NumberField.Sizes.Small, value: value, label: formField.name, onChange: function (newValue) { return dispatch({ key: formField.key, value: newValue }); }, error: error }, formField.props)));
};
var FormField = /** @class */ (function (_super) {
    __extends(FormField, _super);
    function FormField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormField.prototype.shouldComponentUpdate = function (nextProps) {
        return (nextProps.value !== this.props.value ||
            nextProps.error !== this.props.error);
    };
    FormField.prototype.render = function () {
        var _this = this;
        var _a = this.props, formField = _a.formField, value = _a.value;
        if (formField.permissions) {
            if (typeof formField.permissions === 'string') {
                return (React.createElement(lib_permissions_1.WithPermission, { permission: formField.permissions },
                    React.createElement(InnerFormField, __assign({}, this.props))));
            }
            return (React.createElement(lib_permissions_1.WithViewEditPermission, { edit: {
                    permission: formField.permissions.editPermission,
                    component: function () { return React.createElement(InnerFormField, __assign({}, _this.props)); }
                }, view: {
                    permission: formField.permissions.viewPermission,
                    component: function () { return (React.createElement(ReadOnlyValue_1.ReadOnlyValue, { name: formField.name, value: value })); }
                } }));
        }
        return React.createElement(InnerFormField, __assign({}, this.props));
    };
    return FormField;
}(React.Component));
exports.FormField = FormField;
